import { ApiHandlerService } from './api-hanler.service';
import { Injectable } from '@angular/core';
import { AddUpdateOrganizationInput, ControllerList, ControllerOTP, OrganizationProfile, ProfileResponse, updateMyPasswordInput, updateMyProfileInput } from '../models/profile.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiUrls } from '../utilities/APIUris';
import { ResetPasswordResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    private apiHandlerService: ApiHandlerService) {}

  private profileSubject = new BehaviorSubject<updateMyProfileInput | null>(null);

  // Observable that components can subscribe to
  profile$ = this.profileSubject.asObservable();

  getMyProfile() {
    return this.apiHandlerService.doGet<ProfileResponse>(ApiUrls.getProfile, true, true);
  }

  updateMyProfile(payload: updateMyProfileInput) {
    return this.apiHandlerService.doPut(ApiUrls.updateMyProfile, payload, true, true);
  }

  setProfile(profile: updateMyProfileInput) {
    this.profileSubject.next(profile);
  }

  // Method to get current profile
  getCurrentProfile() {
    return this.profileSubject.getValue();
  }

  updateMyPassword(payload: updateMyPasswordInput) {
    return this.apiHandlerService.doPut<ResetPasswordResponse>(ApiUrls.updateMyPassword, payload, true, true);
  }

  // FOR ORGANIZATION
  addMyOrganization(reqPayload: AddUpdateOrganizationInput) {
    return this.apiHandlerService.doPost(ApiUrls.addOrganization, reqPayload, true, true);
  }

  getMyOrganization(orgId: string) {
    return this.apiHandlerService.doGet(`${ApiUrls.getMyOrganization}/${orgId}`, true, true);
  }

  updateMyOrganization(orgId: string, payload: AddUpdateOrganizationInput) {
    return this.apiHandlerService.doPut(`${ApiUrls.updateMyOrganization}/${orgId}`, payload, true, true);
  }

  getControllerOTP(): Observable<ControllerOTP[]> {
    return this.apiHandlerService.doGet(`${ApiUrls.getControllerOTP}`, true, true);
  }

  getControllerList(): Observable<ControllerList[]> {
    return this.apiHandlerService.doGet(`${ApiUrls.getControllerList}`, true, true);
  }

}
